<template>
  <t-select
    v-model="val"
    filterable
    :multiple="false"
    :loading="loading"
    @focus="handleFocus"
    @change="handleChange"
    :onSearch="handleSearch"
    placeholder="请选择"
  >
    <t-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
      <div style="display: flex; justify-content: space-between">
        <div>{{ item.label }}</div>
        <div>{{ item.mobile }}</div>
      </div>
    </t-option>
  </t-select>
</template>

<script>
import { getUserList } from '@/api/application/app';

export default {
  name: 'select-user',
  props: {
    value: [Number, String, Array],
  },
  data() {
    return {
      val: '',
      hasFirstRequest: false,
      loading: false,
      options: [],
    };
  },
  watch: {
    value: {
      deep: true,
      handler() {
        this.val = this.value;
      },
    },
  },
  created() {
    this.val = this.value;
  },
  mounted() {
    this.handleFocus();
  },
  methods: {
    handleFocus() {
      if (!this.hasFirstRequest) {
        this.handleSearch();
        this.hasFirstRequest = true;
      }
    },
    handleChange(v) {
      this.$emit('input', v);
      const findItem = this.options.find(i => i.value === v);
      this.$emit('onChange', {
        entityName: findItem.label,
        phoneNumber: findItem.mobile,
      });
    },
    async handleSearch(q) {
      try {
        this.loading = true;
        const res = await getUserList({
          searchContext: q,
          pageNo: 1,
          pageSize: 200,
        });
        this.options = res.map(i => ({ label: i.name, value: i.id, mobile: i.mobile }));
      } finally {
        this.loading = false;
      }
    },
    onFilterUser(filterWords, item) {
      // console.log('onFilterUser', filterWords, item);
      if (!filterWords) return true;
      const findItem = this.options.find(i => i.value === item.value);
      if (
        (findItem.label && findItem.label.indexOf(filterWords) !== -1) ||
        (findItem.mobile && findItem.mobile.indexOf(filterWords) !== -1)
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped></style>
